import LinkList from './LinkList';
import { H2 } from './styles';
import { HelpAction } from './types';

/** "Do it yourself" -- the account pages that answer a question without us. */
const DO_IT_YOURSELF: HelpAction[] = [
  { label: 'My Orders: check an order, cancel, change an address', href: '/customer?xCmd=orders' },
  { label: 'DiscountLock: turn off or delay a renewal, update your card', href: '/my-account/discountlock' },
  { label: 'Digital library: read a digital magazine', href: '/customer?xCmd=digitallibrary' },
  { label: 'Email preferences', href: '/customer?xCmd=epshow' },
];

export default function DoItYourself() {
  return (
    <div>
      <h2 className={H2}>Do it yourself</h2>
      <LinkList links={DO_IT_YOURSELF} />
    </div>
  );
}
